var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJusticeScales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.649,
    height: 16.61,
    viewBox: "0 0 20.649 16.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "scale-unbalanced-flip-solid",
    d: "M3.928,2.024A1.038,1.038,0,1,1,4.586.055L8.252,1.278A2.593,2.593,0,0,1,13.079,2.6a2.755,2.755,0,0,1-.016.285L17.04,4.208a1.038,1.038,0,0,1-.659,1.969L11.989,4.71a2.759,2.759,0,0,1-.467.266v10.6a1.037,1.037,0,0,1-1.038,1.038H4.255a1.038,1.038,0,1,1,0-2.076H9.446V4.973a2.6,2.6,0,0,1-1.434-1.59L3.928,2.021ZM6.6,9.343,4.255,5.314,1.907,9.343ZM4.255,12.457c-2.041,0-3.737-1.1-4.088-2.56A1.44,1.44,0,0,1,.385,8.856L3.473,3.562a.907.907,0,0,1,1.564,0L8.125,8.856A1.44,1.44,0,0,1,8.343,9.9C7.992,11.354,6.3,12.457,4.255,12.457ZM16.674,9.466,14.325,13.5h4.7Zm4.088,4.584c-.35,1.457-2.047,2.56-4.088,2.56s-3.737-1.1-4.088-2.56a1.44,1.44,0,0,1,.217-1.041l3.088-5.294a.907.907,0,0,1,1.564,0l3.088,5.294a1.44,1.44,0,0,1,.217,1.041Z",
    transform: "translate(-0.14)",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJusticeScales);
export default __webpack_public_path__ + "static/media/justice-scales.75b2428f3994d119e9d02d40470a5148.svg";
export { ForwardRef as ReactComponent };